import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import NodeToggle, { NodeToggleCross } from './NodeToggle';
import { TreeItem } from '.';
import TreeNodeHeader from './TreeNodeHeader';
import nbsp from '../nbsp';

interface TreeNodeItemProps {
    item: TreeItem;
    isSelected: (item: TreeItem) => boolean;
    onNodeClick?: (item: TreeItem) => any;
    onToggle: (item: TreeItem) => any;
    firstChild?: boolean;
    lastChild?: boolean;
}

const useStyles = makeStyles((theme) => ({
    root: {
        cursor: 'pointer',
        position: 'relative',
        padding: 0,
        //paddingLeft: 16,
        display: 'flex',
        alignItems: 'center',
        height: 20,
        color: theme.palette.text.primary,
        '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? 'rgb(20, 73, 97)' : '#dfdfdf',
            color: theme.palette.mode === 'dark' ? 'white' : 'rgba(0, 0, 0, 0.87)'
        },
    },
    fakeToggle: {
        height: 16,
        width: 16
    },
    selectedNodo: {
        backgroundColor: theme.palette.mode === 'dark' ? 'rgb(0, 98, 143)' : '#cfebff',
        fontWeight: 600,
        color: theme.palette.mode === 'dark' ? 'white' : 'rgba(0, 0, 0, 0.87)'
    }
}), { name: 'TreeNodeItem' });

const TreeNodeItem: React.FC<TreeNodeItemProps> = ({ item, isSelected, onNodeClick, onToggle, firstChild, lastChild }) => {
    const classes = useStyles();
    const selected = isSelected(item);
    const children = item.children;

    const classesList = [classes.root];
    if (selected) {
        classesList.push(classes.selectedNodo);
    }
    return (
        <div
            className={classesList.join(' ')}
        >
            {Array.isArray(children) && children.length > 0
                ? <NodeToggle item={item} onToggle={onToggle} firstChild={firstChild} lastChild={lastChild} />
                : <NodeToggleCross firstChild={firstChild} lastChild={lastChild} />}
            <TreeNodeHeader item={item} onNodeClick={onNodeClick} onDoubleClick={onToggle} />
        </div >
    );
}

export default TreeNodeItem;